import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IWeProvide } from "../weProvideModal";

export const getAllWeProvide = createAsyncThunk(
  "WeProvide/FindAllWeProvide",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeProvide/FindAllWeProvide`,
        {
          WeProvideTitle: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WeProvide:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createWeProvide = createAsyncThunk(
  "WeProvide/InsertWeProvide",
  async (WeProvideData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeProvide/InsertWeProvide`,
        WeProvideData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating WeProvide:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateWeProvide = createAsyncThunk(
  "WeProvide/UpdateWeProvide",
  async (WeProvideData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeProvide/UpdateWeProvide`,
        WeProvideData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating WeProvide:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteWeProvide = createAsyncThunk(
  "WeProvide/DeleteWeProvide",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeProvide/DeleteWeProvide`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting WeProvide :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getWeProvideByID = createAsyncThunk(
  "WeProvide/FindByIDWeProvide",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeProvide/FindByIDWeProvide`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        ServiceID: result.ServiceID ? +result.ServiceID : "",
        Title: result.Title ? result.Title : "",
        Subtitle: result.Subtitle ? result.Subtitle : "",
        Description: result.Description ? result.Description : "",
        IsActive: result.IsActive ? 1 : 2,
      } as IWeProvide;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching WeProvide :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveWeProvide = createAsyncThunk(
  "WeProvide/FindAllActiveWeProvide",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/WeProvide/FindAllActiveWeProvide`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching WeProvide:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveWeProvide = createAsyncThunk(
  "WeProvide/ActiveInActiveWeProvide",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeProvide/ActiveInActiveWeProvide`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive WeProvide :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const WeProvideDetailsImageUpload = createAsyncThunk(
  "WeProvide/WeProvideImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WeProvide/WeProvideImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload WeProvide Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
